export const STRIPE_SURCHARGE_LAST_ALLOWED_LOCAL_DATE = '2026-09-30';
export const STRIPE_SURCHARGE_EXPIRY_DISPLAY_DATE = '30 September 2026';

function toLocalYmd(value: Date): string {
  const local = new Date(value.getTime() - (value.getTimezoneOffset() * 60_000));
  return local.toISOString().slice(0, 10);
}

export function isStripeSurchargeAllowed(now = new Date()): boolean {
  return toLocalYmd(now) <= STRIPE_SURCHARGE_LAST_ALLOWED_LOCAL_DATE;
}

export function getDefaultStripeSurchargeEnabled(now = new Date()): boolean {
  return isStripeSurchargeAllowed(now);
}

export function resolveStripeSurchargeEnabledForUi(value: unknown, paymentMode: string, now = new Date()): boolean {
  if (paymentMode !== 'payment_link' || !isStripeSurchargeAllowed(now)) {
    return false;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  const normalized = String(value ?? '').trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  return getDefaultStripeSurchargeEnabled(now);
}
